
<div class="profile-container">
    <div class="">
        <div class="profile-content">  
            <!-- <div class="personal-details">
                <h4 class="personal-details-title">Material Issues list</h4>
                <table class="table table-striped">
                  <thead>
                        <tr>
                          <th scope="col">Issue No</th>
                          <th scope="col">Issue Date</th>
                          <th scope="col">Branch Name</th>
                          <th scope="col">Request By</th>
                          <th scope="col">Request Date</th>
                          <th scope="col">Status</th>
                          <th scope="col">Action</th>
                        </tr>
                  </thead>
                  <tbody>
                        <tr *ngFor="let x of materials | paginate : {
                          itemsPerPage: tableSize,
                          currentPage: pageNumber,
                          totalItems: totalRecords
                        }  ;let i = index">
                        <th scope="col" >{{x.issueNo}}</th>
                        <th scope="col" ><span *ngIf="x.issueDate != 0 && x.issueDate != null">{{x.issueDate | date}}</span> <span *ngIf="x.issueDate == 0 || x.issueDate == null">--</span></th>
                        <th scope="col" >{{x.branchName}}</th>
                        <th scope="col" >{{x.createdByUserName}}</th>
                        <th scope="col" ><span *ngIf="x.createdDate != 0 && x.createdDate != null">{{x.createdDate | date}}</span><span *ngIf="x.createdDate == 0 || x.createdDate == null">--</span> </th>
                        <th scope="col" >{{x.latestStatus}}</th>
                        <th scope="col" >
                          <svg xmlns="http://www.w3.org/2000/svg" (click)="getViewById(x.materialIssueId)" data-toggle="modal" data-target="#viewModal"   width="18" height="18" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
                              <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                              <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                          </svg> 
                        </th>
                        </tr>
                  </tbody>
              </table>
              <div class="pagination-block" *ngIf="materials.length != 0">
                <pagination-controls
                  previousLabel="Prev"
                  nextLabel="Next"
                  (pageChange)="onTableDataChange($event)"
                >
                </pagination-controls>
              </div>
            </div> -->

            <div class="personal-details">

              <div class="header-block">
                  <div class="header-title">
                      <p>Material Issues list</p>
                  </div>
                  <div class="add-block">
                    <div class="search">
                      <form autocomplete="off" >
                        <input type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="searchKey" placeholder="search">
                      </form>
                      <i class="bi bi-x-lg" (click)="refreshSearch()" *ngIf="searchKey != ''"></i>
                      <i class="bi bi-search" (click)="getAllMaterialIssueByWildSearchWithIssueStatus(0,10)"></i>
                    </div>
                      <!-- <button><i class="bi bi-plus-lg"></i> Add</button> -->
                  </div>
              </div>
            
              <table class="table table-striped">
                  <thead>
                      <tr>
                
                          <th style="width: 15%;">Issue No</th>
                          <th style="width: 15%;">Issue Date</th>
                          <th style="width: 15%;">Branch Name</th>
                          <th style="width: 15%;">Request By</th>
                          <th style="width: 15%;">Request Date</th>
                          <th style="width: 15%;">Status</th>
                          <th style="width: 10%;text-align: center;padding: 0;" class="">Action</th>
  
                      </tr>
                  </thead>
              </table>
              <div *ngIf="!isLoading">
                  <div class="data-view" *ngFor="let material of materials | paginate : {
                      itemsPerPage: tableSize,
                      currentPage: pageNumber,
                      totalItems: totalRecords
                      }  ;let i = index">
      
                      <p style="width: 15%">{{material.issueNo}}</p>
                      <p style="width: 15%"><span *ngIf="material.issueDate != 0 && material.issueDate != null">{{material.issueDate | date}}</span> <span *ngIf="material.issueDate == 0 || material.issueDate == null">--</span></p>
                      <p style="width: 15%">{{material.branchName}}</p>
                      <p style="width: 15%">{{material.createdByUserName}}</p>
                      <p style="width: 15%"><span *ngIf="material.createdDate != 0 && material.createdDate != null">{{material.createdDate | date}}</span><span *ngIf="material.createdDate == 0 || material.createdDate == null">--</span> </p>
                      <p style="width: 15%">{{material.latestStatus}}</p>           
                      <p class="action-buttons" style="width: 10%;padding-left: 25px;">
                        <i *ngIf="actionControls.isView" (click)="getViewById(material.materialIssueId)" data-toggle="modal" data-target="#viewModal" class="bi bi-eye-fill"></i>
                      </p>                
                  </div>
              </div>
      
      
              <div class="loader" *ngIf="isLoading">
                  <div class="spinner"></div>
              </div>
      
              <div class="loader"  *ngIf="!isLoading && materials.length == 0">
                  <div class="no-data">
                      <img src="assets/no-data-6.png" alt="">
                      <p>no data found</p>
                  </div>
                  
              </div>
      
              <div class="paginator">
                  <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="totalRecords"
                      [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
              </div>
      
        
          </div>
        </div>
    </div>
  </div>
  
  <div class="modal fade" id="viewModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header" *ngFor="let issue of singleissue">
        <span class="approved" *ngIf="issue.latestStatus != 'REJECTED'">{{issue.latestStatus}}</span>
        <span class="not-approved" *ngIf="issue.latestStatus == 'REJECTED'">{{issue.latestStatus}}</span>
      </div>
      <div class="modal-body" *ngFor="let issue of singleissue">
        <div [formGroup]="form">
            <div class="form-group">
              <div class="row">
                <div class="col-md-6 col-lg-6">
                    <label>Issue No</label>
                    <input readonly formControlName="issueNo" type="number" class="form-control">
                </div>
                <div class="col-md-6 col-lg-6">
                    <label>Issue Date</label>
                    <input readonly formControlName="issueDate" type="text" class="form-control">
                </div>
  
                <div class="col-md-6 col-lg-6">
                  <label>Requested By</label>
                  <input readonly formControlName="createdByUserName" type="text" class="form-control">
              </div>
  
              <div class="col-md-6 col-lg-6">
                <label>Requested Date</label>
                <input readonly formControlName="createdDate" type="text" class="form-control">
            </div>
            </div>
            <div class="row">
              <div class="col-md-12 col-lg-12">
                <label>Branch Name</label>
                <input readonly formControlName="branchName" type="text" class="form-control">
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 col-lg-12">
                  <div *ngFor="let list of productSerialNoList;let i = index">
                    <div class="productList">
                      <div class="row">
                        <div class="col-md-3 col-lg-3">
                          <label for="">Product Name</label>
                          <input class="form-control" readonly  value="{{list.productName}}" type="text">
                        </div>
                        <div class="col-md-3 col-lg-3">
                          <label for="">UOM</label>
                          <input class="form-control" readonly  value="{{list.uomName}}" type="text">
                        </div>
                        <div class="col-md-3 col-lg-3">
                          <label for="">Request Quantity</label>
                          <input class="form-control" readonly value="{{list.requestQty}}" type="text">
                        </div>
                        <div class="col-md-3 col-lg-3">
                          <label for="">Approved Quantity</label>
                          <input class="form-control" readonly value="{{list.approvedQty}}" type="text">
                        </div>
                      
                      </div>
                      <!-- <div class="productQty">
                        <input class="form-control" readonly value="{{list.productName}}" type="text">
                        <input class="form-control" readonly value="{{list.requestQty}}" type="text">
                        <input class="form-control" readonly value="{{list.uomName}}" type="text">
                        
                        <input class="form-control" (keyup)="addInfoObj(i,list.approveQty)" [(ngModel)]="list.approveQty" [ngModelOptions]="{standalone: true}" placeholder="enter quantity" type="number">
                        
                      </div>
                      <div class="infoObj" *ngFor="let infoObj of list.infoObj;let j = index;let last = last">
                        <input type="number" placeholder="enter slNo" class="form-control" [ngModelOptions]="{standalone: true}" [(ngModel)]="productSerialNoList[i].infoObj[j].slNo">
                        <input type="text" placeholder="enter make" class="form-control" [ngModelOptions]="{standalone: true}" [(ngModel)]="productSerialNoList[i].infoObj[j].make">
                        <input type="text" placeholder="enter modal" class="form-control" [ngModelOptions]="{standalone: true}" [(ngModel)]="productSerialNoList[i].infoObj[j].modal">
                        <input type="date" placeholder="enter expiryDate" class="form-control">
                      </div>  -->
                    </div>
                  </div>
                </div>
            </div>
            <div class="status-table">
              <table class="table">
                <thead>
                  <tr>
                    <th style="width: 20%;">User ID</th>
                    <th style="width: 30%;text-align: center;">Status</th>
                    <th style="width: 50%;text-align: center;">Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let status of issue.status; let i = index;let itemLast = last;">
                    <td style="width: 20%;">{{status.userId}}</td>
                    <td style="width: 40%;text-align: center;">{{status.issueStatus}}</td>
                    <td style="width: 40%;text-align: center;" ><span *ngIf="status.updatedDate != 0 && status.updatedDate != null">{{status.updatedDate | date : 'medium'}}</span> <span *ngIf="status.updatedDate == 0 || status.updatedDate == null">--</span></td>
                  </tr>
                </tbody>
              </table>
          </div>
            <div class="modal-footer">
              <!-- <button type="button" (click)="rejectIssue()" *ngIf="issue.latestStatus == 'REQUESTED'"  class="btn btn-danger left" >Reject</button> -->
              <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
              <!-- <button (click)="materialIssue()" type="button" class="btn btn-primary">Issue</button> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
  